import { createReducer } from 'redux-act';
import * as actions from '#app/actions/insurance';

interface InsuranceState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: InsuranceState = {
  modalVisible: false,
  form: {},
};

const setInsuranceModalVisible = (state: InsuranceState, bool: boolean): InsuranceState => ({
  ...state,
  modalVisible: bool,
});

const setInsuranceForm = (
  state: InsuranceState,
  form: Record<string, unknown>
): InsuranceState => ({
  ...state,
  form: form,
});

export default createReducer<InsuranceState>(
  {
    [actions.setInsuranceModalVisible as any]: setInsuranceModalVisible,
    [actions.setInsuranceForm as any]: setInsuranceForm,
  },
  initialState
);
